import { Component, Vue } from "vue-property-decorator";
import { LevelTract } from "./level_tract";
import MarkerLayer from "./Marker";
import { store } from '@/store';
import { IGalaxy } from '@/galaxy-cruise/api_interface';
import { EquatorialCoord } from '@hscmap/angle';
import LevelNames from "./LevelNames";

@Component({
  components: {
    MarkerLayer,
    LevelTract,
    LevelNames,
  },
})
export default class extends Vue {
  gal2coord3(galaxies: IGalaxy[]) {
    return galaxies.map(({ ra, dec }) => EquatorialCoord.fromDeg(ra, dec).xyz)
  }

  get gc() {
    return store.galaxyCruise
  }

  get quest() {
    return this.gc.session!.quest
  }

  get undoneGalaxies() {
    return this.gc.undoneGalaxies.filter((g) => g !== this.gc.targetGalaxy)
  }
}
